// extracted by mini-css-extract-plugin
export default {"content":"style_content__sXOYD","hero":"style_hero__8EjGt","textWrapper":"style_textWrapper__Zz7z-","text":"style_text__QQq3j","text2":"style_text2__6GVKS"};